import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('partCkuMngStore', Object.keys(getters)),
	...mapState('partCkuMngStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('partCkuMngStore', Object.keys(actions)),
	...mapMutations('partCkuMngStore', Object.keys(mutations))
};
